import { useCallback, useReducer } from 'react';

import { interpolateProgressivePoint } from '../../../../../../../services/interpolationService';

export default function useViewAllLogsState() {
  const [state, dispatch] = useReducer(reducer, {
    lazyload: {
      currentChunkIndex: 0,
      chunkEndIndex: 1
    },
    logs: []
  });

  const setAllLogs = useCallback(function(payload) {
    dispatch({
      type: 'SET_ALL_LOGS',
      payload: payload.map(function(log, index) {
        return { ...log, status: index > 0 ? 'PENDING' : 'LOADING' };
      })
    });
  }, []);

  const updateItemInAllLogs = useCallback(function(id, payload) {
    dispatch({
      type: 'UPDATE_ITEM_IN_ALL_LOGS',
      id,
      payload
    });
  }, []);

  return {
    state,
    dispatch,
    setAllLogs,
    updateItemInAllLogs
  };
}

function reducer(state, action) {
  const nextState = getNextState(state, action);
  return handleLogChunksLazyloading(state, nextState);
}

function handleLogChunksLazyloading(state, nextState) {
  const { lazyload, logs } = nextState;
  const chunkEndIndex = lazyload.chunkEndIndex;

  if (state.logs === logs || chunkEndIndex === logs.length) {
    return nextState;
  }

  const numberOfChunks = getNumberOfChunks(1 / logs.length);

  for (const index in logs) {
    const log = logs[index];
    if (log.status === 'LOADING') {
      return nextState;
    }
    if (log.status === 'LOADED') {
      continue;
    }
    if (index >= lazyload.chunkEndIndex) {
      if (chunkEndIndex !== lazyload.chunkEndIndex) {
        break;
      } else {
        lazyload.currentChunkIndex += 1;
        lazyload.chunkEndIndex = interpolateProgressivePoint(
          numberOfChunks,
          lazyload.currentChunkIndex,
          1.82,
          1,
          logs.length
        );
      }
    }
    nextState.logs[index] = {
      ...log,
      status: 'LOADING'
    };
  }
  return {
    ...nextState,
    logs: [...logs]
  };
}

function getNextState(state, action) {
  if (action.type === 'SET_ALL_LOGS') {
    return { ...state, logs: action.payload };
  }
  if (action.type === 'UPDATE_ITEM_IN_ALL_LOGS') {
    return {
      ...state,
      logs: state.logs.map(function(log) {
        if (log.itemGroupTemplateId === action.id) {
          return { ...log, ...action.payload };
        }
        return log;
      })
    };
  }
  return state;
}

function getNumberOfChunks(percentPerUnit) {
  const chunks = [0.5, 0.25, 0.1, 0.045];
  for (let i in chunks) {
    if (percentPerUnit >= chunks[i]) {
      return +i + 1;
    }
  }
  return chunks.length + 1;
}
